import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export class DeliveryMethod {
        name: string;
        id: string;
        active: boolean;
        price: number;
}
export class GetInstanceDeliveryMethodsResponse {
    delivery_methods: DeliveryMethod[] = [];
}

export function getInstanceDeliveryMethods(instance_id: number): Promise<AxiosResponse<GetInstanceDeliveryMethodsResponse>>{
    const path = `/instance/${instance_id}/delivery-methods`;
    return Cirus.get(path);
}